import React from 'react'
import { Row, Card, Button } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { IoIosAddCircleOutline, IoIosCloseCircle } from 'react-icons/io'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { CommonForm } from 'src/views/components'
import { userContainer, teamContainer } from 'src/models'
import { isB2B2C } from 'src/utils'
import { getValidationSchema } from './validationScema'
import { getFormInput } from './formInput'
import './styles.scss'

const classNameValue = {
  formClassName: 'flex-grow-1 user-invite-form position-relative mt-3',
}

@observer
class UserInviteForm extends React.Component {
  @observable isToExpandCheckboxDropDown = false

  handleClickOutside = event => {
    const element =
      typeof this.checkBoxRefNode != 'undefined' &&
      this.checkBoxRefNode &&
      this.checkBoxRefNode.lastElementChild &&
      this.checkBoxRefNode.lastElementChild.id
    if (
      typeof this.checkBoxRefNode != 'undefined' &&
      this.checkBoxRefNode &&
      !this.checkBoxRefNode.contains(event.target)
    ) {
      this.isToExpandCheckboxDropDown = false
      document.getElementById(element).style.display = 'none'
    }
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }
  renderSubmitButton = () => {
    const { active = false, inviteUserState } = this.props
    const disabled = inviteUserState.userData.length >= 4 ? true : false
    if (active) {
      return (
        <Button
          variant="light"
          onClick={() => {
            inviteUserState.isFromSendInvite = false
          }}
          className="border-white bg-white p-0 invite-user"
          type="submit"
          disabled={disabled}
          data-testid="qa-add-email-address">
          <IoIosAddCircleOutline />
        </Button>
      )
    } else {
      return (
        <Button
          variant="light"
          className="border-white bg-white p-0 invite-user position-absolute"
          type="submit"
          data-testid="qa-add-email-address">
          <IoIosCloseCircle />
        </Button>
      )
    }
  }

  renderSendInviteButton = () => {
    const { submitData } = this.props
    return (
      <Row noGutters className="mt-3">
        <Button
          type="submit"
          variant="primary"
          className="send-invite create-team-button d-flex px-3 py-1 justify-content-center align-items-center mt-3 col-lg-4"
          onClick={() => {
            submitData()
          }}
          data-testid="qa-send-invite">
          {i18nTranslate('userInvite.send', 'Send Invite')}
        </Button>
        <Button
          onClick={() => this.props.handleInviteUser()}
          variant="outline-dark"
          className="cancel-invite ml-0 ml-lg-3 d-flex px-3 py-1 justify-content-center align-items-center col-lg-4 mt-3"
          data-testid="qa-cancel-invite-user">
          {i18nTranslate('inviteuser.cancel', 'Cancel')}
        </Button>
      </Row>
    )
  }

  handleteam = () => {
    const { teams = [] } = teamContainer.filteredTeamsData
    const modifiedteam = teams.map((team, index) => {
      const { status = '', name } = team
      if (status == 'active') {
        return {
          [`${name}_${index}`]: name,
        }
      }
    })
    return modifiedteam
  }

  handleSubmit = async data => {
    const { userEmailAddress, userRole, userTeam, firstName, lastName } = data
    const { active = false, index } = this.props
    const { inviteUserState } = this.props
    if (active) {
      inviteUserState.userData.push({
        email: userEmailAddress,
        role: userRole,
        team: isB2B2C() ? this.handleteam() : userTeam,
        firstName,
        lastName,
      })
    } else {
      inviteUserState.userData.splice(index, 1)
    }
    if (inviteUserState.isFromSendInvite === true) {
      inviteUserState.shouldShowDisabledForm = false
      await userContainer.userInvite(inviteUserState.userData)
      userContainer.getUsersList({ page: this.props.activePage || 1 })
      inviteUserState.userData = []
      inviteUserState.isFromSendInvite = false
      inviteUserState.shouldShowDisabledForm = true
    }
  }

  handleCheckBoxRefNode = node => {
    this.checkBoxRefNode = node
  }

  handleDropDownClick = event => {
    event.persist()
    let checkboxes = document.getElementById('checkboxes')

    if (!this.isToExpandCheckboxDropDown) {
      checkboxes.style.display = 'block'
      this.isToExpandCheckboxDropDown = true
    } else {
      checkboxes.style.display = 'none'
      this.isToExpandCheckboxDropDown = false
    }

    const dropdownHeight = checkboxes.offsetHeight
    if (dropdownHeight > 200) {
      checkboxes.style.height = '10rem'
      checkboxes.style.overflow = 'auto'
    }
  }
  render() {
    const { isToResetForm = false, active = false } = this.props
    return (
      <CommonForm
        schema={getValidationSchema(this.props)}
        formTypeJson={getFormInput({
          ...this.props,
          handleRef: this.handleCheckBoxRefNode,
          handleDropDownClick: this.handleDropDownClick,
          inviteButton: this.renderSendInviteButton(),
        })}
        classNameValue={classNameValue}
        SubmitButtonProps={this.renderSubmitButton}
        hasInlineSubmitButton={active}
        onSubmit={this.handleSubmit}
        isToResetForm={isToResetForm}
        renderBothButtons={active}
      />
    )
  }
}

@observer
class UserInvite extends React.Component {
  @observable inviteUserState = {
    userData: [],
    isFromSendInvite: false,
    shouldShowDisabledForm: true,
  }

  renderUserInviteData = (data, index) => {
    return (
      <UserInviteForm
        {...data}
        inviteUserState={this.inviteUserState}
        index={index}
        key={index}
        {...this.props}
      />
    )
  }

  submitData = () => {
    this.inviteUserState.isFromSendInvite = true
  }

  render() {
    return (
      <Card className="mb-2" data-testid="qa-invite-user-container">
        <Card.Body className="p-3">
          <Card.Title className="m-0" data-testid="qa-user-management">
            {i18nTranslate('userInvite.title', 'User Management')}
          </Card.Title>
          <div>
            {this.inviteUserState.shouldShowDisabledForm &&
              this.inviteUserState.userData.length > 0 &&
              this.inviteUserState.userData.map(this.renderUserInviteData)}
            <UserInviteForm
              inviteUserState={this.inviteUserState}
              active
              isToResetForm
              submitData={this.submitData}
              {...this.props}
            />
          </div>
        </Card.Body>
      </Card>
    )
  }
}

export { UserInvite }
export default UserInvite
